// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"af3cae0c","66":"2f9f0d6a","105":"ea4c47fb","148":"b977f978","243":"7f218643","343":"c47a9035","364":"fa06b383","440":"ff443ecb","444":"0fb1c062","625":"874ceaef","665":"9021be75","728":"8888da55","748":"3127056e","940":"b5dffb03","967":"d87e8791","983":"00f5820a"}[chunkId] + ".chunk.js";
};